import React, { FC, useMemo } from 'react';
import { AnalyticsUserSessionsCountProps } from './AnalyticsUserSessionsCountProps';
import { BarChartPro } from '@mui/x-charts-pro/BarChartPro';
import AnalyticsLoader from '../AnalyticsLoader';
import { groupDataByMonth } from './utils';

const AnalyticsUserSessionsCount: FC<AnalyticsUserSessionsCountProps> = ({
  data,
  grouping,
  loading,
}) => {
  const chartData: any = useMemo(() => {
    if (grouping && grouping === 'month') {
      return groupDataByMonth(data);
    }

    return data;
  }, [data, grouping]);

  return (
    <AnalyticsLoader loading={loading}>
      <BarChartPro
        dataset={chartData}
        xAxis={[
          {
            scaleType: 'band',
            dataKey: 'date',
            tickLabelStyle: { angle: -45 },
          },
        ]}
        yAxis={[
          {
            dataKey: 'number',
          },
        ]}
        series={[
          {
            dataKey: 'number',
            label: 'Sessions',
          },
        ]}
        slots={{
          noDataOverlay: () => null,
        }}
      />
    </AnalyticsLoader>
  );
};

export default AnalyticsUserSessionsCount;
